var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "24px",
    height: "24px",
    viewBox: "-2.4 -2.4 28.80 28.80",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    strokeWidth: 0.00024000000000000003,
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.192
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.011,5.743A3.106,3.106,0,0,1,5.155,3h8.69a3.106,3.106,0,0,1,3.144,2.743A2.989,2.989,0,0,1,15,8.816V19a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V8.816A2.989,2.989,0,0,1,2.011,5.743ZM20,19V8.816a2.989,2.989,0,0,0,1.989-3.073A3.106,3.106,0,0,0,18.845,3h-3a3.106,3.106,0,0,1,3.144,2.743A2.989,2.989,0,0,1,17,8.816V19a2,2,0,0,1-2,2h3A2,2,0,0,0,20,19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipe);
export default __webpack_public_path__ + "static/media/recipe.19128f8e668cc6c92b33d4d1918c9e9f.svg";
export { ForwardRef as ReactComponent };